module.exports = {"140211100":"古店镇","140211101":"高山镇","140211102":"云冈镇","140211200":"口泉乡","140211201":"新旺乡","140211202":"水泊寺乡","140211205":"马军营乡","140211206":"西韩岭乡","140211207":"平旺乡","140211210":"鸦儿崖乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140211.json
// module id = 359
// module chunks = 0